module.exports = __webpack_public_path__ + "media/images/icons/mercadopago_desktop-97149f584ea5490980c2fe939c5a875b.svg";